<button ion-button
        clear
        color="primary-blue"
        [disabled]="isInitializing"
        (click)="addList($event)">ADD TO LIST</button>
